import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col } from 'react-bootstrap'

//components
import withLocalization from '~/hoc/withLocalization';
import Select from '../../../../elements/Select';

//utils
import { translateLabels } from '../../../../utils/commonMethods';

const messageControlOptions = [{ value: "read", label: 'members can only read', key: 'members can only read' },
{ value: "read_write", label: 'members can read and write', key: 'members can read and write' }]

class MessageControl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messageRules: {
                messageSetting: 'read_write'
            },
        }
        this.handleSwitch = this.handleSwitch.bind(this);
        this.loadData = this.loadData.bind(this);
    }

    loadData = () => {
        const { currentEntity } = this.props.clientStore;
        const { messageRules } = this.state;
        if (currentEntity.client.data && currentEntity.client.data.basicRules) {
            const basicRules = Object.assign({}, currentEntity.client.data.basicRules);
            messageRules.messageSetting = basicRules.messageSetting ? basicRules.messageSetting : 'read_write';

        }
    }

    componentDidMount() {
        this.loadData();
    }

    handleSwitch = (name, evt) => {
        const { messageRules } = this.state;
        messageRules[name] = evt;
        this.props.handleUserDataChange(name, evt);
        this.setState({ messageRules })
    }

    render() {
        const { messageRules } = this.state;
        const { t } = this.props;
        translateLabels(messageControlOptions, t, 'label');
        return (
            <div>
                <Row>
                    <Col sm={6} xs={12}>
                        <label className="control-label">{t('Message')} {t('Chat properties')}</label>
                        <Select
                            options={messageControlOptions}
                            value={messageControlOptions.find(item => item.value === messageRules.messageSetting)}
                            onChange={evt => this.handleSwitch('messageSetting', evt.value)}
                        />
                    </Col>
                </Row>

            </div>
        );
    }
}
export default inject('clientStore')(withLocalization(observer(MessageControl)));